import { Form } from "@ant-design/compatible";
import { Button, Modal } from "antd";
import { isFunction } from "lodash";
import { useState } from "react";
import { connect } from "react-redux";

import { UPDATE_PASSWORD_LIMIT_DAYS } from "shared/constant";
import CONFIG from "./config";

function ChangePasswordModal({ open, onOk, onCancel, form }) {
  const [loading, setLoading] = useState(false);
  const { getFieldsValue, getFieldDecorator, validateFields } = form;
  const { password } = getFieldsValue();

  const handleOk = async () => {
    setLoading(true);
    try {
      const values = await validateFields();
      console.log(values);
      if (isFunction(onOk)) await onOk(values);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const handleCancel = () => {
    if (isFunction(onCancel)) onCancel();
  };

  const validatePassword = (rule, value, callback) => {
    if (!value) callback("");
    else if (value.length < 8) callback("密碼長度需大於8");
    else if (!(value.match("[a-z]") && value.match("[A-Z]") && value.match("[0-9]")))
      callback("密碼組成需包含英文大寫、小寫字元與數字");
    else callback();
  };

  const validateRepeat = (rule, value, callback) => {
    if (value && value !== password) callback("密碼與上述密碼不同");
    else callback();
  };

  const formItems = CONFIG.getForm({ password, validatePassword, validateRepeat });

  return (
    <Modal
      title="更新密碼通知"
      open={open}
      onCancel={handleCancel}
      footer={[
        <Button loading={loading} type="primary" onClick={handleOk}>
          立即更新
        </Button>
      ]}
    >
      目前的密碼已經超過{UPDATE_PASSWORD_LIMIT_DAYS}
      天未更新，為了保障您的安全，請儘速變更您的登入密碼。
      <Form wrapperCol={{ span: 18 }} labelCol={{ span: 6 }}>
        {formItems.map(({ label, key, rules, child }) => (
          <Form.Item label={label} key={key}>
            {getFieldDecorator(key, { initialValue: "", rules })(child)}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
}

export default connect()(Form.create()(ChangePasswordModal));
